import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ExperimentOutlined, RollbackOutlined } from "@ant-design/icons";

import { GALLERY_DRAFTS } from "./galleryDrafts";
import { MainColor, SubColor } from "../../style/styleValue";

interface Props {
  active: string;
}

const GalleryDraftBar = ({ active }: Props) => {
  const navigate = useNavigate();
  const current = GALLERY_DRAFTS.find((d) => d.key === active);

  return (
    <Bar>
      <Left>
        <Badge>
          <ExperimentOutlined /> 디자인 시안
        </Badge>
        {current && <Tagline>{current.tagline}</Tagline>}
      </Left>

      <Right>
        <Switcher>
          {GALLERY_DRAFTS.map((draft) => (
            <SwitchItem
              key={draft.key}
              $active={draft.key === active}
              onClick={() => navigate(draft.path)}
              title={draft.tagline}
            >
              {draft.name}
            </SwitchItem>
          ))}
        </Switcher>
        <BackLink onClick={() => navigate("/gallery")}>
          <RollbackOutlined /> 현재 디자인
        </BackLink>
      </Right>
    </Bar>
  );
};

const Bar = styled.div`
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding: 10px 24px;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(6px);
  border-bottom: 1px solid #eef1f5;
`;

const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  padding: 3px 10px;
  border-radius: 999px;
  background: ${MainColor};
  color: #fff;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
`;

const Tagline = styled.span`
  font-size: 0.8rem;
  color: #8a94a3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: 900px) {
    display: none;
  }
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Switcher = styled.div`
  display: flex;
  padding: 3px;
  border-radius: 999px;
  background: #f2f4f7;
`;

const SwitchItem = styled.button<{ $active: boolean }>`
  border: none;
  cursor: pointer;
  padding: 5px 14px;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: ${({ $active }) => ($active ? 700 : 500)};
  color: ${({ $active }) => ($active ? "#fff" : "#667085")};
  background: ${({ $active }) => ($active ? SubColor : "transparent")};
  transition: background 0.2s ease, color 0.2s ease;

  &:hover {
    color: ${({ $active }) => ($active ? "#fff" : MainColor)};
  }
`;

const BackLink = styled.button`
  border: 1px solid #dbe2ea;
  background: #fff;
  cursor: pointer;
  padding: 5px 12px;
  border-radius: 999px;
  font-size: 0.78rem;
  color: #667085;
  display: inline-flex;
  align-items: center;
  gap: 5px;

  &:hover {
    color: ${MainColor};
    border-color: ${SubColor};
  }
`;

export default GalleryDraftBar;
